export const ORGANIZATIONS_API_ENDPOINTS = {
  ORGANIZATIONS: "/internal/organizations",
} as const;
